import { z } from "@/zod";
import { isFuture } from "date-fns";
import i18n from "@/i18n";

export const birthDate = z
  .string()
  .date()
  .refine((date) => !isFuture(new Date(date)), {
    message: i18n.t("validation.birth_date_in_future"),
  });

export const birthDateOptional = z
  .string()
  .date()
  .refine((date) => !isFuture(new Date(date)), {
    message: i18n.t("validation.birth_date_in_future"),
  })
  .nullable();
